module.exports = __webpack_public_path__ + "assets/img/19.8f34c5a2.png";